import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadTransportListSuccessful, loadTransportListFailed, loadTransportListBegin,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

export default function* loadTransportList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
    } = payload;
    // let pool = {
    //   limit,
    //   page,
    // };
    // if (typeof filter === 'object' && Object.keys(filter).length) {
    //   yield delay(LOADING_DELAY);
    //   pool = addFilterQueryWithCondition(filter, pool);
    // }
    yield put(loadTransportListBegin());
    const url = `${BACKEND_URL}/v1/vehicles`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();

    if (dataResponse.status === OK) {
      yield put(loadTransportListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadTransportListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadTransportListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
